module.exports = __webpack_public_path__ + "static/media/downArrowIcon.7d7f5774.svg";